export default __webpack_public_path__ + "static/join-0e184389b85ec3371e57aa1eda65470b.svg";